<div class="wrapper scrollbar-wrapper" #el1 [@changeState]="currentState">
  <ng-scrollbar
    *ngIf="format$ | async as format"
    (reachedBottom)="loadNewEpisodes()"
    reachedOffset="1"
  >
    <mat-card #el2 class="p-2 pt-2 format" (click)="hideEpisodes()">
      <mat-icon color="primary" class="me-2" *ngIf="(data$ | async)?.length != 1; else empty">
        arrow_back
      </mat-icon>
      <ng-template #empty> <mat-icon></mat-icon> </ng-template>

      <div>
        <div class="small font-weight-bold item-title">{{ format.title }}</div>
        <div class="d-flex">
          <div class="small item-description pe-3" *ngIf="producer$ | async">
            {{ 'list.formatContentId' | translate }}
            {{ format.contentFormatId }}
          </div>
          <div class="small item-description" *ngIf="format.childs.length !== 0; else noResults">
            {{ 'list.episodeNumber' | translate }}
            {{ format.totalChildResults }}
          </div>
          <ng-template #noResults>
            <div class="small item-description">
              {{ 'list.noEpisodes' | translate }}
            </div>
          </ng-template>
        </div>
      </div>
    </mat-card>

    <div
      class="div"
      [@episodeAnimation]="format"
      *ngIf="format.childs.length !== 0; else noEpisodes"
    >
      <mat-card
        #el2
        class="p-2 episode"
        *ngFor="let episode of format.childs"
        (click)="selectEpisode(episode)"
        [ngClass]="{
          selected: episode.episodeNr === (episode$ | async)
        }"
      >
        <mat-icon color="accent" class="me-2">play_circle_filled_white </mat-icon>

        <div>
          <div class="small font-weight-bold item-title">
            {{ episode.title }}
          </div>
          <div class="d-flex">
            <div class="small item-description pe-3">{{ episode.boNr }}</div>
            <div class="small item-description">EpisodeNr: {{ episode.episodeNr }}</div>
          </div>
        </div>
      </mat-card>
    </div>
    <ng-template #noEpisodes>
      <div class="d-flex justify-content-center align-items-center flex-row empty-search pt-2">
        <mat-icon class="me-1">play_circle_filled_white</mat-icon>
        <span>{{ 'list.episodeNotFound' | translate }}</span>
      </div></ng-template
    >
  </ng-scrollbar>
</div>
